import React from "react"
import { PieChart, Pie, Tooltip } from "recharts"
import numeral from "numeral"
import cx from "classnames"

export default class DonutChart extends React.PureComponent {
    static defaultProps = {
        size: 150,
        thickness: 4,
        data: [],
    }

    render() {
        const percentage = this.props.percentage === 0 ? 0.0001 : this.props.percentage

        let theCValue = this.props.size / 2
        let theOuterRadius = theCValue - 10
        let theInnerRadius = theCValue - (10 + this.props.thickness)
        let theData = percentage ? [{ value: percentage }, { value: 100 - percentage }] : this.props.data

        let cn = cx("dna-donut-chart", this.props.className, {})

        return (
            <div className={cn} style={{ width: this.props.size }}>
                {percentage >= 0 && !this.props.customLabel && (
                    <h4
                        className={"dna-donut-label"}
                        style={{ fontSize: this.props.fontSize, marginTop: this.props.label ? 0 : 10 }}
                    >
                        <span>{percentage >= 100 ? parseInt(percentage) : numeral(percentage).format("0")}%</span>
                    </h4>
                )}
                {percentage >= 0 && !this.props.customLabel && this.props.label && (
                    <label className="dna-sub-label">{this.props.label}</label>
                )}

                {!percentage && percentage !== 0 && !this.props.customLabel && (
                    <span className="dna-donut-label">
                        <label className="dna-clear">{this.props.label}</label>
                    </span>
                )}

                {this.props.customLabel && this.props.customLabel}

                <PieChart
                    margin={{ top: 0, left: 0, right: 0 }}
                    width={this.props.size}
                    height={this.props.size}
                >
                    <Pie
                        data={theData}
                        dataKey="value"
                        cx={theCValue}
                        cy={theCValue}
                        startAngle={90}
                        endAngle={-270}
                        cornerRadius={2}
                        innerRadius={theInnerRadius}
                        outerRadius={theOuterRadius}
                    />
                    {!percentage && percentage !== 0 && <Tooltip />}
                </PieChart>
            </div>
        )
    }
}
